export const editLocaleInfo = (locale) => {
  let editedLocale = { countryCode: locale };
  if (locale.data) {
    const geoLocale = {
      continent: locale.data["geoplugin_continentName"].trim(),
      continentCode: locale.data["geoplugin_continentCode"].trim(),
      country: locale.data["geoplugin_countryName"].trim(),
      countryCode: locale.data["geoplugin_countryCode"].toLowerCase().trim(),
      region: locale.data["geoplugin_region"].trim(),
      city: locale.data["geoplugin_city"].trim(),
      provincia: locale.data["geoplugin_regionName"].trim(),
      provinciaCode: locale.data["geoplugin_regionCode"].trim(),
      currency: locale.data["geoplugin_currencyCode"].trim(),
      currencySyldol: locale.data["geoplugin_currencySymbol"].trim(),
      latitude: locale.data["geoplugin_latitude"].trim(),
      longitude: locale.data["geoplugin_longitude"].trim(),
      timezone: locale.data["geoplugin_timezone"].trim(),
    };
    editedLocale = geoLocale;
  }
  return editedLocale;
};
